import { useState, FC, useEffect } from 'react';
import { useSendTaskMutation, useUpdateTaskDeadlineMutation } from '../../api/tenders';
import { tenderDataProps } from '../../pages/TenderViewPage/types';
import { Button, Tooltip, message } from 'antd';
import { useAppSelector } from '../../hooks';
import LetterIcon from '../../assets/LetterIcon.svg';
import arrow from '../../assets/arrow-right-white.svg';
import moment from 'moment';
import { TaskDeadlineModal } from '../Modals/TaskDeadline';
import './phases.scss';
import { SupplierListNew } from './DesignPhaseComponents/SupplierListNew';
import { CompletionResultModal } from '../Modals/CompletionResultModal';
import attention from '../../assets/attention.svg';

interface PropsPhase {
    data: tenderDataProps;
    setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
    setConfirmModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const EvaluatePhase3: FC<PropsPhase> = ({ data, setTrigger, setConfirmModal }) => {
    const { role } = useAppSelector((state) => state.profileReducer);
    const [deadlineModal, setDeadlineModal] = useState(false);
    const [SelectedDate, setSelectedDate] = useState<Date | string>(new Date());
    const [isComplationModal, setIsCompetionModal] = useState(false);

    const [updateDeadline, { isLoading }] = useUpdateTaskDeadlineMutation();

    const updateDeadlineFunc = async () => {
        try {
            const formData = {
                id: data.id,
                data: { deadline_at: moment(SelectedDate).format('YYYY-MM-DD') }
            };
            await updateDeadline(formData).unwrap();
            await setDeadlineModal(false);
            await setTrigger((prev: boolean) => !prev);
        } catch {}
    };

    const [
        sendTask,
        { data: dataSendTask, isError: isErrorSendTask, isSuccess: isSuccessSendTask, isLoading: isLoadingSendTask }
    ] = useSendTaskMutation();

    const [messageApi, contextHolder] = message.useMessage();

    const sendTaskFunc = async () => {
        let formData = {};

        formData = {
            id: data?.id
        };
        try {
            await sendTask(formData).unwrap();
            await setTrigger((prev: boolean) => !prev);
        } catch {}
    };

    useEffect(() => {
        if (isErrorSendTask) {
            messageApi.error('Something went wrong, please try again');
        }
        if (isSuccessSendTask) {
            messageApi.success(dataSendTask.message);
        }
    }, [isErrorSendTask, isSuccessSendTask]);

    const taskHeaderDeadlineAt = role === 'school_user' ? data?.tasks_deadline_at : data?.phase_deadline_at;

    const evaluate_3_suppliers = data?.phase_tasks?.find((elem) => elem.action === 'evaluate_3_suppliers');

    return (
        <>
            {contextHolder}
            <div className={`tendermain__block tasks`}>
                <div className="tasks__header define">
                    <div className="count-wrapper">
                        Task Centre
                        <div className="count">{data?.phase_task_count}</div>
                    </div>
                    {taskHeaderDeadlineAt && (
                        <div className="tasks__deadline-wrapper">
                            <img src={attention} alt="" />
                            Task Deadline - {moment(taskHeaderDeadlineAt).format('YYYY-MM-DD')}
                        </div>
                    )}
                </div>

                <div className="tasks__list">
                    {role !== 'school_user' && evaluate_3_suppliers && data?.tasks_deadline_at && (
                        <div className="tasks__info-wrap info-wrap" style={{ margin: '0 0 16px 0' }}>
                            <div className="info-wrap__deadline">Task Deadline for Buyer</div>
                            <div className="info-wrap__status">
                                {moment(data?.tasks_deadline_at).format('YYYY-MM-DD')}
                            </div>
                        </div>
                    )}
                    {data.phase_tasks.length ? (
                        <SupplierListNew data={data} role={role} messageApi={messageApi} setTrigger={setTrigger} />
                    ) : (
                        <>
                            {role === 'school_user' && (
                                <div className="noTasks">
                                    <img src={LetterIcon} />
                                    <div className="noTasks__title"> Welcome to Evaluation Gate 2!</div>
                                    <div className="noTasks__subtitle">
                                        Watch this space - new tasks for you will be posted here as they become
                                        available.
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>

                {role === 'tender_representative' &&
                    data?.phase_tasks?.[0]?.status === 'pending_tr' &&
                    !data.can_update_phase && (
                        <div className="tasks__btn-wrap">
                            <div style={{ width: '47%' }}></div>

                            <Tooltip
                                title={
                                    !data?.can_send_task && data.phase_tasks[1]?.status !== 'pending_su'
                                        ? !data?.suppliers?.every((elem) => elem.grade?.value)
                                            ? 'To send this task, you need to assign a score to each supplier first'
                                            : 'To send this task, you need to complete all the Task Activities'
                                        : ''
                                }
                                overlayClassName={` ${
                                    !data?.can_send_task ? 'custom-tooltip-disabled' : 'custom-tooltip'
                                }`}
                            >
                                <Button
                                    className={`tasks__next-btn ${data?.can_send_task ? '' : 'disabled'}`}
                                    type="primary"
                                    onClick={() => {
                                        if (!data?.can_send_task) {
                                            return;
                                        } else {
                                            if (!isLoadingSendTask) {
                                                sendTaskFunc();
                                            }
                                        }
                                    }}
                                >
                                    Send Task <img src={arrow} />
                                </Button>
                            </Tooltip>
                        </div>
                    )}

                {role === 'school_user' &&
                    data.phase_tasks.length > 0 &&
                    data.phase_tasks?.find((elem) => elem.action === 'evaluate_3_suppliers')?.status ===
                        'pending_su' && (
                        <div className="tasks__btn-wrap">
                            <div></div>

                            <Tooltip
                                title="To send this task, you need to complete all the Task Activities"
                                overlayClassName={` ${
                                    !data?.can_send_task ? 'custom-tooltip-disabled' : 'custom-tooltip'
                                }`}
                            >
                                <Button
                                    className={`tasks__next-btn ${data?.can_send_task ? '' : 'disabled'}`}
                                    type="primary"
                                    style={{ width: '180px' }}
                                    onClick={() => {
                                        if (data?.can_send_task) {
                                            setIsCompetionModal(true);
                                        }
                                    }}
                                >
                                    Generate Scores <img src={arrow} />
                                </Button>
                            </Tooltip>
                        </div>
                    )}
                {role === 'school_user' &&
                    data.phase_tasks.length > 0 &&
                    data.phase_tasks?.find((elem) => elem.action === 'evaluate_3_suppliers')?.status ===
                        'need_approve_su' && (
                        <div className="tasks__btn-wrap">
                            <div></div>

                            <Tooltip
                                title="To send this task, you need to complete all the Task Activities"
                                overlayClassName={` ${
                                    !data?.can_update_phase ? 'custom-tooltip-disabled' : 'custom-tooltip'
                                }`}
                            >
                                <Button
                                    className={`tasks__next-btn ${data?.can_update_phase ? '' : 'disabled'}`}
                                    type="primary"
                                    style={{ width: '180px' }}
                                    onClick={() => {
                                        if (data?.can_update_phase) {
                                            setConfirmModal(true);
                                        }
                                    }}
                                >
                                    Request Pricing <img src={arrow} />
                                </Button>
                            </Tooltip>
                        </div>
                    )}
            </div>
            {deadlineModal && (
                <TaskDeadlineModal
                    openModal={deadlineModal}
                    setOpenModal={setDeadlineModal}
                    SelectedDate={SelectedDate}
                    setSelectedDate={setSelectedDate}
                    updateDeadlineFunc={updateDeadlineFunc}
                    isLoading={isLoading}
                    data={data}
                />
            )}

            {isComplationModal && (
                <CompletionResultModal
                    openModal={isComplationModal}
                    setOpenModal={setIsCompetionModal}
                    data={data}
                    setTrigger={setTrigger}
                />
            )}
        </>
    );
};
